import React from 'react';
import { AttachFileOutlined } from '@material-ui/icons';
import { Grid, Tooltip } from '@mui/material';
import { toast } from 'react-toastify';
import { usePoliticaDeAnexos } from '../../services/politicaDeAnexos';
import { validarAnexo, aceitosNoSeletor } from '../../utils/validacaoDoAnexo';

/**
 * O anexo do chat.
 *
 * ## O que estava errado aqui (13/10/2026)
 *
 * 1. **O arquivo grande sumia em silêncio.** A regra era
 *    `if (file.size / 1000000 < 21) setSelectedFile(file)` -- sem `else`. O
 *    operador escolhia um arquivo de 30 MB e NADA acontecia: nem envio, nem
 *    mensagem, nem pista.
 * 2. **Os 21 MB não eram o limite.** O servidor recusava a partir de 10 MB
 *    (`MessageController@storeArchive`, `max:10240`). Entre 10 e 21 MB o
 *    arquivo subia inteiro para ser rejeitado do outro lado.
 * 3. **O seletor oferecia `image/png, image/jpeg, .json`.** Nem PDF aparecia
 *    na janela de escolha, enquanto o servidor aceitava uma lista bem maior.
 *
 * Agora o limite e os tipos vêm de `GET /politica-de-anexos`, os mesmos que o
 * servidor usa, e a recusa diz o motivo real.
 */
const SendFileIcon = ({ setSelectedFile }) => {
  let inputFileUpload = '';
  const politica = usePoliticaDeAnexos();

  const handleSendFileClick = event => {
    event.preventDefault();
    inputFileUpload.click(); // Abre o seletor de arquivos
  };

  const handleSendFile = event => {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      const { ok, motivo } = validarAnexo(file, politica);

      if (ok) {
        setSelectedFile(file); // Armazena o arquivo selecionado no estado do componente pai
      } else {
        // O `else` que não existia. Sem ele o arquivo era descartado em
        // silêncio, e o operador ficava clicando achando que a tela travou.
        toast.error(motivo);
      }
    }

    event.target.value = null; // Limpa o valor do input
  };

  const titulo = politica
    ? `Anexar arquivo (máx. ${politica.limiteMb} MB)`
    : 'Anexar arquivo';

  return (
    <Grid sx={{ backgroundColor: 'transparent' }}>
      <Tooltip title={titulo} placement="top" arrow>
        <AttachFileOutlined
          className="btn-send-file"
          onClick={handleSendFileClick}
        />
      </Tooltip>
      <input
        type="file"
        name="fileUpload"
        ref={input => inputFileUpload = input}
        style={{ display: 'none' }}
        onChange={handleSendFile}
        // Montado dos MESMOS tipos que o servidor aceita. Antes era
        // `image/png, image/jpeg, .json`, e as duas listas divergiam.
        accept={aceitosNoSeletor(politica) || undefined}
      />
    </Grid>
  );
};

export default SendFileIcon;
